/**
 * DRAFT: not yet approved/published item by admin PUBLISHED: already approved/published item by admin REJECTED: it\'s rejection reason field is filled out
 */
export type ContentStatus = 'DRAFT' | 'PUBLISHED' | 'REJECTED' | 'ONGOING';

export const ContentStatus = {
  Draft: 'DRAFT' as ContentStatus,
  Published: 'PUBLISHED' as ContentStatus,
  Rejected: 'REJECTED' as ContentStatus,
  Ongoing: 'ONGOING' as ContentStatus,
};
